import {
  FlexRow,
  formatHash,
  HashLength,
  NamedKeyPrefix,
  useMatchMedia,
} from '@make-software/cspr-design';
import { HistoryLink } from '../history-link/history-link';
import React from 'react';
import { deriveSplitDataFromNamedKeyValue } from '../../domain';
import { buildRouterPath } from '../../router/utils';
import { SEARCH_PATH } from '../../router/paths';

interface NamedKeyValueProps {
  namedKey: string;
  noPrefix?: boolean;
  hashLength?: HashLength;
}

// TODO: MOVE TO LIB
export const NamedKeyValue = ({
  namedKey,
  noPrefix,
  hashLength,
}: NamedKeyValueProps) => {
  const responsiveHashLength = useMatchMedia(
    [HashLength.TINY, HashLength.MEDIUM, HashLength.FULL, HashLength.FULL],
    []
  );
  const { prefix, hash, path } = deriveSplitDataFromNamedKeyValue(namedKey);

  const isURefNamedKey = namedKey.includes(NamedKeyPrefix.UREF);
  const redirectHash = isURefNamedKey ? namedKey : hash;

  const redirectPath = path
    ? buildRouterPath(path, { id: redirectHash }, undefined)
    : buildRouterPath(SEARCH_PATH, { id: redirectHash }, undefined);
  return (
    <FlexRow>
      {redirectPath ? (
        <HistoryLink href={redirectPath}>
          {!noPrefix && prefix}
          {formatHash(hash, hashLength ?? responsiveHashLength)}
        </HistoryLink>
      ) : (
        formatHash(hash, hashLength ?? responsiveHashLength)
      )}
    </FlexRow>
  );
};

export default NamedKeyValue;
